"use client";
import { Box, CircularProgress, IconButton } from "@mui/material";
import { CloseIcon } from "@/icons";
import { ImagesConstant } from "@/const";
import { IUploadFile } from "@/models";
import React from "react";
import ReactPlayer from "react-player";
import { VIDEO_RATIO } from "@/const/app.const";

const VideoView = ({
  data,
  isLoading,
  onClearFile,
  videoRatio = VIDEO_RATIO,
}: VideoViewProps) => {
  // TODO: remove logic get thumb video

  // const [thumbPreview, setThumbPreview] = useState<String[]>();

  // useEffect(() => {
  //   if (data) {
  //     CommonUtils.getVideoSnapshots([data])
  //       .then((snapshots) => {
  //         setThumbPreview(snapshots);
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       });
  //   }
  // }, [data]);
  return (
    <Box width="100%" position="relative">
      <Box
        className="w-full rounded-1 overflow-hidden border border-[#BDC1CAFF] border-dashed h-[unset]"
        sx={{
          aspectRatio: videoRatio,
        }}
      >
        {isLoading ? (
          <Box
            className="flex items-center justify-center w-full h-full"
            width="100%"
            height="100%"
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <ReactPlayer
              className="video-preview"
              url={data?.link}
              light={ImagesConstant.VideoImageDefault}
              width={"100%"}
              height={"100%"}
              muted
              controls
            />
            <IconButton
              className="absolute -top-[11px] -right-[11px] p-1 bg-white border border-solid"
              onClick={onClearFile}
            >
              <CloseIcon className="text-[12px]" />
            </IconButton>
          </>
        )}
      </Box>
      <Box className="text-ellipsis text-[13px] mt-2 font-medium">
        {data?.originName}
      </Box>
    </Box>
  );
};

type VideoViewProps = {
  data?: IUploadFile;
  isLoading?: boolean;
  onClearFile?: () => void;
  videoRatio?: number;
};

export default VideoView;
